<template>
  <UiModalShell
    :show="props.showModal"
    title="Add Group"
    size="md"
    @close="closeModal"
  >
    <!-- Body -->
    <form id="group-modal-form" @submit.prevent="submitForm" class="space-y-4">
      <!-- First Name -->
      <div>
        <label class="block font-mono text-[10.5px] uppercase tracking-[0.14em] text-text-3 mb-1.5">
          First name <span class="text-err">*</span>
        </label>
        <UiInput
          v-model="first_name"
          placeholder="Enter first name"
        />
      </div>

      <!-- Last Name -->
      <div>
        <label class="block font-mono text-[10.5px] uppercase tracking-[0.14em] text-text-3 mb-1.5">
          Last name <span class="text-err">*</span>
        </label>
        <UiInput
          v-model="last_name"
          placeholder="Enter last name"
        />
      </div>

      <!-- Email -->
      <div>
        <label class="block font-mono text-[10.5px] uppercase tracking-[0.14em] text-text-3 mb-1.5">
          Email <span class="text-err">*</span>
        </label>
        <UiInput
          v-model="email"
          type="email"
          placeholder="Enter email address"
        />
      </div>

      <!-- Contact Number -->
      <div>
        <label class="block font-mono text-[10.5px] uppercase tracking-[0.14em] text-text-3 mb-1.5">
          Contact number <span class="text-err">*</span>
        </label>
        <UiInput
          v-model="contact_number"
          type="tel"
          placeholder="Enter contact number"
        />
      </div>

      <!-- Site -->
      <div>
        <label class="block font-mono text-[10.5px] uppercase tracking-[0.14em] text-text-3 mb-1.5">
          Site <span class="text-err">*</span>
        </label>
        <UiSelect v-model="selectedSite">
          <option
            v-for="site in sites"
            :key="site.siteId"
            :value="site.siteId"
          >
            {{ site.siteName }}
          </option>
        </UiSelect>
      </div>

      <!-- Group Name -->
      <div>
        <label class="block font-mono text-[10.5px] uppercase tracking-[0.14em] text-text-3 mb-1.5">
          Group name <span class="text-err">*</span>
        </label>
        <UiSelect v-model="selectedGroup">
          <option value="" disabled>Select a group</option>
          <option
            v-for="group in groupsList"
            :key="group.GroupId"
            :value="group.GroupId"
          >
            {{ group.GroupName }}
          </option>
        </UiSelect>
      </div>
    </form>

    <template #footer>
      <UiButton
        variant="ghost"
        @click="closeModal"
      >
        Cancel
      </UiButton>
      <UiButton
        variant="primary"
        type="submit"
        form="group-modal-form"
      >
        Save Group
      </UiButton>
    </template>
  </UiModalShell>
</template>

<script setup>
import { ref, watchEffect } from "vue";
import { useStore } from "vuex";
import UiModalShell from "@/components/ui/UiModalShell.vue";
import UiButton from "@/components/ui/UiButton.vue";
import UiInput from "@/components/ui/UiInput.vue";
import UiSelect from "@/components/ui/UiSelect.vue";

const props = defineProps({
  showModal: Boolean,
  customersList: Array
});

const emit = defineEmits(["close", "save"]);
const store = useStore();

const first_name = ref("");
const last_name = ref("");
const email = ref("");
const contact_number = ref("");
const selectedGroup = ref("");
const groupsList = ref([]);

const selectedSite = ref("FA669BD0-42F8-4EDF-8847-9ACD191759F1");
const sites = ref([
  { siteName: "Dubai", siteId: "FA669BD0-42F8-4EDF-8847-9ACD191759F1" },
  { siteName: "Abu Dhabi", siteId: "A8B87580-1745-408A-A9FB-0D27E4F7CE2D" },
]);

const closeModal = () => {
  emit("close");
};

async function getGroups(siteId) {
  const apiURL = store.state.apiUrl + "getGroupsBySite/" + siteId;
  try {
    const response = await fetch(apiURL);
    if (!response.ok) {
      throw new Error("Something went wrong!");
    }
    const data = await response.json();
    return data[1].groups;
  } catch (error) {
    console.error("Error fetching customers:", error);
    return [];
  }
}

watchEffect(() => {
  getGroups(selectedSite.value).then((groups) => {
    groupsList.value = groups;
  });
});

const submitForm = () => {
  // selectedGroup stores the GroupId (string); look up the full row from
  // groupsList to reconstruct the group object for the emitted payload.
  const groupRow = groupsList.value.find(
    (g) => g.GroupId === selectedGroup.value
  );
  const groupPayload = groupRow
    ? {
        group_id: groupRow.GroupId,
        group_name: groupRow.GroupName,
        site_name: groupRow.SiteName,
      }
    : null;

  const customer = {
    first_name: first_name.value,
    last_name: last_name.value,
    email: email.value,
    customer_logo: "URL",
    contact_number: contact_number.value,
    primary_account: groupPayload ? groupPayload.group_id : undefined,
    role: "ACCOUNT_ADMIN",
    group: groupPayload ? [groupPayload] : [],
    account_type: "SUPPLIER",
  };
  emit("save", customer);

  // Clear the form
  first_name.value = "";
  last_name.value = "";
  email.value = "";
  contact_number.value = "";
  selectedGroup.value = "";

  closeModal();
};
</script>
